module.exports = __webpack_public_path__ + "img/consumer-image-intro-page.80064126.png";